 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		13: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		13: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"commons","2":"2830047292ef2a956a8553fa66d4dfe2c6ebe3f4","3":"0177cb17b6fe47484187ce7969c35e030481cec9","4":"074e5b8b333cc6c3088426a2676033ffa26f1b26","5":"1f86229a7fb2d1b0922f3309c7071a9aded6d5cf","6":"5e3c721f2c93ec47e8113da9f1b502461c8bbfed","7":"f81d698fc3d67d80957a9f09edb2b744a7330ecf","8":"e3e8247f14ffacd79d163e4591601a109066ae64","9":"c344b8081f4e0f5203f130728fa2ba95d718fbab","11":"ea7365721a21f33b7471dd373ee4b58e8a272042","12":"framework","14":"74fdba35","15":"a908dc70","17":"c9184924","18":"component---src-pages-404-js","19":"component---src-pages-account-create-js","20":"component---src-pages-account-login-js","21":"component---src-pages-account-offers-js","22":"component---src-pages-account-price-lists-js","23":"component---src-pages-expertise-how-to-js","24":"component---src-pages-online-stockists-js","25":"component---src-pages-preview-page-js","26":"component---src-pages-preview-post-js","27":"component---src-pages-product-search-js","28":"component---src-pages-quote-builder-js","29":"component---src-pages-stockist-search-js","30":"component---src-templates-brand-js","31":"component---src-templates-category-js","32":"component---src-templates-how-to-js","33":"component---src-templates-list-news-posts-js","34":"component---src-templates-list-posts-js","35":"component---src-templates-news-post-js","36":"component---src-templates-page-js","37":"component---src-templates-post-js","38":"component---src-templates-product-js","39":"component---src-templates-tag-js"}[chunkId]||chunkId) + "-" + {"0":"407fe62976dc5310c43e","1":"4c2d14e843f3c313916a","2":"0246439da9afbcf6212b","3":"fad79d1fb17fb110aa14","4":"e63baefacccf4f30ca79","5":"b3a2e86a5707a525e622","6":"9e6d85efdc34e6abb4f3","7":"db925307903e677b3f80","8":"48efd881482448a178bb","9":"16bf341ba5bdcd8d7bac","11":"34100953fa57967b8c1d","12":"7c88d397b8769df8a204","14":"ef00bcfcd3df21d003d5","15":"98fe5e5125379eba888a","17":"d43c46a7f5788ca14244","18":"9f000feb80f4ec877b28","19":"b33a8636c6cc99664ef9","20":"4cb54b95b44074dbebb6","21":"2ec5f5600579d16e3b0e","22":"865346e8f5cc8a5457ef","23":"6c4c1d8f669c4156dd18","24":"e93c7259c3d31fff83b4","25":"a7bac88b33b9b03772df","26":"af45c7e187df208e01ce","27":"8e0c106fad219d5a40cb","28":"7200fa74fa5ccb6e5959","29":"e8593aabfbf65f50afdb","30":"1ef2051c5f9353828d68","31":"b786bcde26307c3953d0","32":"437c9b664b9c99b2ab98","33":"05ed91b6336f638304ae","34":"4d13c881d7a01245d477","35":"e2eea8a0d5fbe6dc446e","36":"47159b916899bc8d8504","37":"7d1cf9265b4d77e728a4","38":"c883b9dd1849288625ed","39":"4c3f3cb116688e652671"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"commons","2":"2830047292ef2a956a8553fa66d4dfe2c6ebe3f4","3":"0177cb17b6fe47484187ce7969c35e030481cec9","4":"074e5b8b333cc6c3088426a2676033ffa26f1b26","5":"1f86229a7fb2d1b0922f3309c7071a9aded6d5cf","6":"5e3c721f2c93ec47e8113da9f1b502461c8bbfed","7":"f81d698fc3d67d80957a9f09edb2b744a7330ecf","8":"e3e8247f14ffacd79d163e4591601a109066ae64","9":"c344b8081f4e0f5203f130728fa2ba95d718fbab","11":"ea7365721a21f33b7471dd373ee4b58e8a272042","12":"framework","14":"74fdba35","15":"a908dc70","17":"c9184924","18":"component---src-pages-404-js","19":"component---src-pages-account-create-js","20":"component---src-pages-account-login-js","21":"component---src-pages-account-offers-js","22":"component---src-pages-account-price-lists-js","23":"component---src-pages-expertise-how-to-js","24":"component---src-pages-online-stockists-js","25":"component---src-pages-preview-page-js","26":"component---src-pages-preview-post-js","27":"component---src-pages-product-search-js","28":"component---src-pages-quote-builder-js","29":"component---src-pages-stockist-search-js","30":"component---src-templates-brand-js","31":"component---src-templates-category-js","32":"component---src-templates-how-to-js","33":"component---src-templates-list-news-posts-js","34":"component---src-templates-list-posts-js","35":"component---src-templates-news-post-js","36":"component---src-templates-page-js","37":"component---src-templates-post-js","38":"component---src-templates-product-js","39":"component---src-templates-tag-js"}[chunkId]||chunkId) + "." + {"0":"0adaf36857f33b5d07bf","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/plumbing/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
